<template>
  <router-link
    :class="['sj-layout-header-logo', collapse ? 'collapse' : '']"
    :to="to">
    <div v-show="collapse">
      <slot :collapse="collapse"
            name="collapse">
      </slot>
    </div>
    <div v-show="!collapse">
      <slot :collapse="collapse">
      </slot>
    </div>
  </router-link>
</template>

<script>
export default {
  name: 'SjLayoutLogo',
  inject: ['SjLayout'],
  props: {
    to: {
      type: [Object, String],
      default: '/',
    },
  },
  data () {
    return {}
  },
  computed: {
    collapse () {
      if (this.SjLayout) {
        return this.SjLayout.collapse
      }
      return false
    },
    currentUrl () {
      return this.collapse ? this.collapseUrl : this.url
    },
  },
  watch: {},
  methods: {},
}
</script>

<style lang="scss" scoped>
.sj-layout-header-logo {
  height: 50px;
  cursor: pointer;
  color: white;
  line-height: 50px;
  text-align: center;
  transition: width 0.2s, background 0.2s;
  background-color: #424f63;
  width: 200px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;

  &.collapse {
    width: 64px;
  }

  img {
    user-select: none;
    pointer-events: none;
  }
}
</style>

<style lang="scss"
       scoped>
</style>
